export default __webpack_public_path__ + "static/media/logo-vertical-white.999779c7.png";